import type { Appointment } from '../../lib/api.js';

export type DepositState = 'PAID' | 'WAIVED' | 'LATE_REQUEST' | 'EXPIRED' | 'PENDING';

/// Em que pé está o sinal do pedido (ADR 0058). Nulo quando o pedido não acompanha sinal: sem
/// valor, já confirmado ou encerrado.
export function depositStateOf(appointment: Appointment, now: number): DepositState | null {
  if (!appointment.depositAmountCents || appointment.status !== 'SCHEDULED') return null;
  if (appointment.depositWaivedAt) return 'WAIVED';
  if ((appointment.depositPaidCents ?? 0) >= appointment.depositAmountCents) return 'PAID';
  const due = appointment.depositDueAt ? Date.parse(appointment.depositDueAt) : null;
  if (due !== null && appointment.requestedAt && due <= Date.parse(appointment.requestedAt))
    return 'LATE_REQUEST';
  if (due !== null && due <= now) return 'EXPIRED';
  return 'PENDING';
}
